import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectInput from '../../../common/inputs/select-input';
import { withEditSpot } from '../../../../../spots/hoc/withEditSpot';

var RepliesDepthKeys = {
  ONE: { value: 1, text: '1' },
  TWO: { value: 2, text: '2' },
  THREE: { value: 3, text: '3 (default)' },
  FOUR: { value: 4, text: '4' },
  FIVE: { value: 5, text: '5' },
  SIX: { value: 6, text: '6' }
};

function getRepliesDepth(value) {
  var repliesDepth = null;
  switch (value) {
    case 1:
      repliesDepth = RepliesDepthKeys.ONE;
      break;
    case 2:
      repliesDepth = RepliesDepthKeys.TWO;
      break;
    case 4:
      repliesDepth = RepliesDepthKeys.FOUR;
      break;
    case 5:
      repliesDepth = RepliesDepthKeys.FIVE;
      break;
    case 6:
      repliesDepth = RepliesDepthKeys.SIX;
      break;
    default:
      repliesDepth = RepliesDepthKeys.THREE;
      break;
  }
  return repliesDepth;
}

class MaxRepliesDepth extends Component {
  static propTypes = {
    maxRepliesDepth: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
    spotId: PropTypes.string
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  static displayName = 'RepliesDepth';

  handleDepthChange(depth) {
    this.props.editSpot(this.props.spotId, { comment_replies_max_depth: depth.value });
  }

  render() {
    var { maxRepliesDepth } = this.props;
    let value = getRepliesDepth(maxRepliesDepth);

    return (
      <div className="platform-selection">
        <SelectInput
          title="Conversation Levels"
          description="Set how many levels of replies will be used when users reply to each other."
          onChange={this.handleDepthChange.bind(this)}
          options={[
            RepliesDepthKeys.ONE,
            RepliesDepthKeys.TWO,
            RepliesDepthKeys.THREE,
            RepliesDepthKeys.FOUR,
            RepliesDepthKeys.FIVE,
            RepliesDepthKeys.SIX
          ]}
          value={value}
        />
      </div>
    );
  }
}

export default withEditSpot(MaxRepliesDepth);
